import { create } from 'zustand'

import type { ClientPlatform } from '@/lib/config/env'

export interface UpdateDecision {
  required: boolean
  forced: boolean
  currentVersion: string
  minimumVersion: string
  /** Platform-specific store URL; `null` on web and when the server omits it. */
  storeUrl: string | null
  platform: ClientPlatform
}

interface GateState {
  update: UpdateDecision | null
  termsRequired: boolean
  currentTermsVersion: string | null
  setUpdate: (update: UpdateDecision | null) => void
  setLegalStatus: (status: {
    requiresTermsAcceptance: boolean
    currentTermsVersion: string
  }) => void
  setTermsRequired: (required: boolean) => void
  markTermsAccepted: () => void
  resetGates: () => void
}

const INITIAL = {
  update: null,
  termsRequired: false,
  currentTermsVersion: null,
}

/**
 * Auth gate flags only. Kept in its own store (rather than in the startup
 * orchestrator) so session helpers can clear the terms gate on logout without
 * creating an import cycle.
 */
export const useGateStore = create<GateState>()((set) => ({
  ...INITIAL,

  setUpdate: (update) => set({ update }),

  setLegalStatus: ({ requiresTermsAcceptance, currentTermsVersion }) =>
    set({
      termsRequired: requiresTermsAcceptance,
      currentTermsVersion,
    }),

  setTermsRequired: (termsRequired) => set({ termsRequired }),

  markTermsAccepted: () => set({ termsRequired: false }),

  resetGates: () => set({ ...INITIAL }),
}))
